<template>
    <div>
        <el-form ref="form" :model="form" label-width="70px" size="mini" style="width: 450px">
            <el-form-item label="兑换码: ">
                <el-input style="width: 200px" v-model="form.code" clearable></el-input>
                <el-button style="margin-left: 20px" type="primary" @click="query()">查询</el-button>
            </el-form-item>
        </el-form>

        <div style="margin-left: 13px" v-if="this.detail">
            <el-descriptions :column="1" title="" style="width: 600px" border>
                <el-descriptions-item>
                    <template slot="label"> 生成时间 </template>
                    {{ $util.ms2datetime(this.detail.cycle.createdAt)}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label"> 生成人 </template>
                    {{ this.detail.cycle.adminUsername }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label"> 自定义兑换码 </template>
                    {{ this.detail.cycle.isNotUseSuffix ? "是" : "否" }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label"> 单个兑换码可被使用次数 </template>
                    {{ this.detail.cycle.useCount == 0 ? "无限次": this.detail.cycle.useCount  }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label"> 已使用次数 </template>
                    {{ this.detail.usedTimes  }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label"> 适用渠道 </template>
                    {{ this.detail.cycle.channel }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label"> 礼包名称 </template>
                    {{ this.detail.gift.name }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">礼包内道具 </template>
                    <div v-for="(item, index) in  this.detail.gift.props" :key="index">
                        {{ attachments[item.id] }} x {{ item.amount }}
                    </div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label"> 生效日期（当天零点生效）</template>
                    {{   this.detail.cycle.startAt != "0" ? $util.ms2day(this.detail.cycle.startAt) : ""  }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label"> 失效日期（当天零点失效）</template>
                    {{   this.detail.cycle.endAt != "0" ? $util.ms2day(this.detail.cycle.endAt) : ""  }}
                </el-descriptions-item>
               
                <el-descriptions-item>
                    <template slot="label"> 备注 </template>
                    {{ this.detail.cycle.remark }}
                </el-descriptions-item>

            </el-descriptions>
        </div>
    </div>
</template>

<script>

const axios = require("axios");


export default {
    data() {
        return {
            form: {
                code: "",
            },
            detail:null,
            attachments: {},
        };
    },

    components: {

    },
    async created() {
        this.attachments = await this.$bizutil.loadAttachments(true)
        // this.loadList();
    },
    methods: {
        /**
       *
       */
        async query() {
            if(this.form.code.trim().length == 0){
                this.$message({
                        message:"请输入兑换码",
                        type: "error",
                    });
                    return;
            }
            try {
                let resData = (
                    await axios.post(
                        `${this.$util.getBackendApiBase()}/v1/admin/queryRedeemCodeDetail`,
                        {
                            code: this.form.code,
                        },
                        {
                            headers: {
                                token: this.$bizutil.getLoginUserToken(),
                            },
                        }
                    )
                ).data;
                if (resData.code > 0) {
                    this.$message({
                        message: resData.message,
                        type: "error",
                    });
                    return;
                }

                this.detail = resData.data || null;

            } catch (e) { }
        },
    },
}
</script>



<style lang="scss" scoped>
/deep/ .el-table__row td {
    padding: 3px 0;
}

/deep/ .el-table .cell {
    line-height: 18px;
}

.link-button {
    padding-left: 10px;
    color: rgb(37, 148, 240);
    cursor: pointer;
}
</style>